module.exports = __webpack_public_path__ + "static/media/wanessa.5c3c183c.png";